<div class="org-selecter-dialog">
  <h6>Select Organisation</h6>
  <div mat-dialog-content>
    <div class="form-input">
      <mat-form-field>
        <mat-select [compareWith]="compareFn" [(ngModel)]="currentOrganisation" [ngModelOptions]="{standalone: true}">
          <mat-option *ngFor="let org of organisationsList" [value]="org">{{org.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div mat-dialog-actions class="pull-right">
    <button mat-button (click)="onDialogClose()">Cancel</button>
    <button mat-button class="color-success-light" (click)="onDialogClose('okBtn')" cdkFocusInitial>Ok</button>
  </div>
</div>
